export default __webpack_public_path__ + "static/media/MAS.44aaa7f7.svg";